import type { CaseDate, ServiceDate } from '../../types/dates'

type CaseDates = {
  case: CaseDate[]
  service: ServiceDate[]
}

export const caseDates: CaseDates = {
  case: [
    'created_at',
    'updated_at',
    'archived_at',
    'date_of_birth',
    'date_of_death',
    'date_of_marriage',
    'interment_date',
    'service_date',
  ],

  service: ['created_at', 'updated_at', 'date', 'time', 'endTime', 'startTime'],
}

export default caseDates
